import React from 'react';
import Page1 from "./Page1";
import Page2 from "./Page2";
import Page3 from "./Page3";
import Page4 from "./Page4";
import Page5 from "./Page5";
import Page6 from "./Page6";
import Page7 from "./Page7";
import {scrollToTop} from "../../../../../../libs/helpers";

export default class HowToBeConfidentInYourJudgementCalls extends React.Component {

    constructor(props) {
        super(props);

        this.state = {
            currentPage: 'Page1',
            pageData: props.pagesData?.['HowToBeConfidentInYourJudgementCalls']?.data || null
        };
    }

    pages = {
        Page1: Page1,
        Page2: Page2,
        Page3: Page3,
        Page4: Page4,
        Page5: Page5,
        Page6: Page6,
        Page7: Page7
    }

    handleChangePage = (currentPage) => _ => {
        this.setState({
            currentPage
        });

        scrollToTop();
    }

    handleChangePageData = (type) => (event) =>  {
        this.setState({
            pageData: {
                ...this.state.pageData,
                [type]: {
                    ...this.state.pageData?.[type],
                    [event.target.name]: event.target.value
                }

            }
        });
    }

    savePageData = (nextPage) => () => {

        this.handleChangePage(nextPage)();

        if (JSON.stringify(this.state.pageData) !== JSON.stringify(this.props.pagesData?.['HowToBeConfidentInYourJudgementCalls']?.data))
            this.props.savePageData()('HowToBeConfidentInYourJudgementCalls', this.state.pageData);
    }

    render() {

        const Page = this.pages[this.state.currentPage] || 'Page1';

        return (
            <Page handleChangePage={this.handleChangePage}
                  handleChangeMainPage={this.props.handleChangePage}
                  handleChangePageData={this.handleChangePageData}
                  incompletePage={!this.state.pageData?.status}
                  pageData={this.state.pageData}
                  savePageStatus={this.props.savePageStatus}
                  savePageData={this.savePageData}/>
        );
    }
}